import Marquee from "react-fast-marquee";
import { AREAS } from "../site";

export const AreasMarquee = () => (
  <section id="coverage" data-testid="coverage-section" className="py-16 md:py-24 border-y border-zinc-200 bg-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-10 mb-10 flex items-end justify-between gap-6">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-400 mb-3">Service area</p>
        <h2 className="font-heading text-3xl md:text-5xl font-semibold tracking-tight text-zinc-950">
          All of Winnipeg. <span className="text-zinc-400">Zero towing.</span>
        </h2>
      </div>
      <p className="hidden md:block max-w-xs text-sm leading-relaxed text-zinc-500">
        Fully mobile vans cover every neighbourhood — from the Exchange District
        to the Perimeter and beyond.
      </p>
    </div>

    <Marquee speed={35} gradient={false} data-testid="areas-marquee" aria-label="Winnipeg service areas">
      {AREAS.map((area) => (
        <span key={area} className="flex items-center">
          <span className="font-mono uppercase tracking-[0.2em] text-4xl md:text-6xl text-zinc-300 px-6 md:px-10 select-none">
            {area}
          </span>
          <span className="h-2 w-2 rounded-full bg-brand/40" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </section>
);
